module.exports = __webpack_public_path__ + "static/media/idisc-xpress.e282e399.jpg";